(function () {
  var CYCLE = ['THB', 'USD', 'EUR'];
  var SYMBOLS = { THB: '฿', USD: '$', EUR: '€' };
  var rates = { THB: 1, USD: 0.0292, EUR: 0.0270 };
  var current = localStorage.getItem('tik_cur') || 'THB';

  fetch('https://open.er-api.com/v6/latest/THB')
    .then(function(r){ return r.json(); })
    .then(function(d){ rates.USD = d.rates.USD; rates.EUR = d.rates.EUR; convertAll(); })
    .catch(function(){});

  function parseTHB(text) {
    var n = parseFloat(text.replace(/[^0-9.]/g, ''));
    return isNaN(n) || n < 1 ? null : n;
  }

  function fmt(thb, cur) {
    var val = Math.round(thb * rates[cur]);
    return SYMBOLS[cur] + val.toLocaleString('en-US');
  }

  var SEL = '.tour-card__price-value, .carousel-item__price, .tour-price, #total-price, #btn-price';
  // Add-on price labels carry surrounding text (e.g. "+500 THB / group"), so they
  // are seeded separately: we keep the label text as a template and only swap the price token.
  var LABEL_SEL = '.addon-price-label';
  var PH = '￿'; // placeholder that never occurs in copy

  function seedPrices() {
    document.querySelectorAll(SEL).forEach(function(el) {
      if (el.hasAttribute('data-thb')) return;
      var thb = parseTHB(el.textContent);
      if (thb) el.setAttribute('data-thb', thb);
    });
  }

  function seedLabel(el) {
    // Match a number immediately followed by the currency word, e.g. "500 THB".
    // Theme scripts rewrite labels in THB (e.g. changeGuideLanguage), so a label whose
    // text contains "NNN THB" is always fresh THB copy — (re)seed from it.
    var m = el.textContent.match(/([0-9][0-9,]*)\s*THB/i);
    if (!m) return; // "Price on confirmation" / already-converted labels — leave them.
    var thb = parseFloat(m[0].replace(/[^0-9.]/g, ''));
    if (isNaN(thb) || thb < 1) return;
    el.setAttribute('data-thb', thb);
    el.setAttribute('data-cur-tpl', el.textContent.replace(m[0], PH));
  }

  function seedLabels() {
    document.querySelectorAll(LABEL_SEL).forEach(seedLabel);
  }

  function convertAll() {
    seedLabels(); // pick up labels (re)written in THB by theme scripts since last pass
    document.querySelectorAll('[data-thb]').forEach(function(el) {
      var thb = parseFloat(el.getAttribute('data-thb'));
      if (isNaN(thb)) return;
      var tpl = el.getAttribute('data-cur-tpl');
      var out = tpl ? tpl.replace(PH, fmt(thb, current)) : fmt(thb, current); // label: keep surrounding text
      if (el.textContent !== out) el.textContent = out; // no-op writes keep the observer from looping
    });
    var btn = document.getElementById('tik-cur-btn');
    if (btn) btn.textContent = current;
    document.querySelectorAll('.tik-currency-btn').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-currency') === current);
    });
  }

  function cycle() {
    var idx = CYCLE.indexOf(current);
    current = CYCLE[(idx + 1) % CYCLE.length];
    localStorage.setItem('tik_cur', current);
    convertAll();
  }

  function injectButton() {
    if (document.getElementById('tik-cur-btn')) return;
    var btn = document.createElement('button');
    btn.id = 'tik-cur-btn';
    btn.textContent = current;
    btn.setAttribute('aria-label', 'Change currency');
    btn.addEventListener('click', cycle);
    var actions = document.querySelector('.header-actions');
    if (actions) actions.insertBefore(btn, actions.firstChild);
  }

  // EU members + EFTA + UK. UK gets EUR because we don't carry GBP.
  var EU = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','GB','CH','NO','IS','LI'];
  // Anglophone + APAC markets that mentally price in USD.
  var USD_MARKETS = ['US','CA','MX','AU','NZ','SG','HK','JP','PH','MY','ID','IN','BR','AR','CL','CO','KR','TW','SA','AE','IL','ZA','TR','RU'];

  function autoDetect() {
    if (localStorage.getItem('tik_cur')) return;
    if (localStorage.getItem('tik_geo_tried')) return;
    localStorage.setItem('tik_geo_tried', '1');
    fetch('https://ipapi.co/country/')
      .then(function(r){ return r.text(); })
      .then(function(country){
        var c = (country || '').trim().toUpperCase();
        if (!/^[A-Z]{2}$/.test(c)) return;
        var target = null;
        if (c === 'TH') target = 'THB';
        else if (EU.indexOf(c) >= 0) target = 'EUR';
        else if (USD_MARKETS.indexOf(c) >= 0) target = 'USD';
        if (!target || target === current) return;
        current = target;
        localStorage.setItem('tik_cur', target);
        convertAll();
      })
      .catch(function(){});
  }

  function watchLabels() {
    // Theme scripts rewrite some labels in THB (e.g. guide language switch).
    // Re-seed and re-render those labels so a non-THB view stays converted.
    if (!window.MutationObserver) return;
    var container = document.querySelector('.addons-container');
    if (!container) return;
    new MutationObserver(function() {
      // convertAll only writes on real text changes, so this can't loop.
      if (current !== 'THB') convertAll();
      else seedLabels();
    }).observe(container, { childList: true, characterData: true, subtree: true });
  }

  function init() {
    injectButton();
    seedPrices();
    seedLabels();
    watchLabels();
    if (current !== 'THB') convertAll();
    autoDetect();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  window.tikSetCurrency = function(c) {
    current = c; localStorage.setItem('tik_cur', c); convertAll();
  };
})();
